import { render, staticRenderFns } from "./salesLog.vue?vue&type=template&id=378a4e10&"
import script from "./salesLog.vue?vue&type=script&lang=js&"
export * from "./salesLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports